// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function CloudSlashIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M6.74 4.327a1 1 0 1 0-1.48 1.346l4.905 5.396-.007.015A8 8 0 1 0 9 27h11c1.36.003 2.708-.249 3.975-.741l1.285 1.413a1 1 0 1 0 1.48-1.345l-20-22ZM20 25H9a6 6 0 1 1 .412-11.985A11.05 11.05 0 0 0 9 16a1 1 0 1 0 2 0c0-1.136.215-2.261.633-3.318l10.875 11.963A8.958 8.958 0 0 1 20 25Zm11-9a10.986 10.986 0 0 1-2.794 7.326A1 1 0 0 1 26.714 22 9 9 0 0 0 14.67 8.75a1 1 0 0 1-1.185-1.611A11 11 0 0 1 31 16Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
